import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_k_button = _resolveComponent("k-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["close-button-header", { 'close-button-header-bg': _ctx.background }])
  }, [
    _createVNode(_component_k_button, {
      icon: "close",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
      class: "close-button-header-btn"
    })
  ], 2))
}